import { render, staticRenderFns } from "./RequestLetterSodorEsterdad.vue?vue&type=template&id=23d34a5a&scoped=true&"
import script from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
export * from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
import style0 from "./RequestLetterSodorEsterdad.vue?vue&type=style&index=0&id=23d34a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d34a5a",
  null
  
)

export default component.exports